export enum MetadataOrderType {
  Adebs,
  Streaming,
  Cinelink,
  AdebsProIdiom,
  AdebsSamsungLynk
}
